
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/payment-initiation/virtual-accounts/account-sweeping",
      function () {
        return require("private-next-pages/docs/payment-initiation/virtual-accounts/account-sweeping.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/payment-initiation/virtual-accounts/account-sweeping"])
      });
    }
  